export { default as PrimaryHeading } from './PrimaryHeading'
export { default as SecondaryHeading } from './SecondaryHeading'
